import React from 'react'

const useHideFromSpiders = ({ hideFromSpiders }) => {
  if (hideFromSpiders !== null && hideFromSpiders !== undefined && hideFromSpiders === true) {
    return <meta name="robots" content="noindex"></meta>
  }

  return null
}

export default useHideFromSpiders
